<div
  *ngIf="(areAllSecuritiesSame$ | async) === false; else singleSecuritySelected"
  class="d-flex flex-column w-100 h-100"
>
  <hs-panel-card header="Multiple Different Securities Selected">
    <p>
      This panel requires same securities to be selected before information can
      be displayed. Select a single security or same multiple securities to
      continue .
    </p>
  </hs-panel-card>
</div>

<ng-template #singleSecuritySelected>
  <ng-container
    *ngIf="areAllSecuritiesSame$ | async; else noSecuritiesSelected"
  >
    <!--https://medium.com/@pietmichal/angulars-content-projection-trap-and-why-you-should-consider-using-template-outlet-instead-cc3c4cad87c9-->
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </ng-container>
</ng-template>

<ng-template #noSecuritiesSelected>
  <hs-panel-card header="No Security Selected">
    <p>
      This panel requires a security to be selected before information can be
      displayed. Select a security in the Clearwater Transaction panel to
      continue.
    </p>
  </hs-panel-card>
</ng-template>
